import classnames from 'classnames';

import styles from './ProjectThumbnail.module.scss';
import { Props } from './ProjectThumbnail.types';

const initialOf = (title: string) => title.trim().charAt(0).toUpperCase() || '·';

const ProjectThumbnail = ({ title, imageUrl, hasVoteBadge }: Props) => (
  <div className={styles.container}>
    {imageUrl ? (
      <img src={imageUrl} alt="" className={classnames(styles.tile, styles.image)} loading="lazy" />
    ) : (
      <div className={classnames(styles.tile, styles.placeholder)} aria-hidden>
        {initialOf(title)}
      </div>
    )}
    {hasVoteBadge && (
      <span className={styles.voteBadge} aria-hidden>
        🗳
      </span>
    )}
  </div>
);

export default ProjectThumbnail;
